import React from "react";
import { useFormat } from "@/contexts/FormatContext";

export default function FormatToggle() {
  const { format, setFormat, formats, resolvedFormat } = useFormat();
  const SHORT = { "1qb": "1QB", superflex: "SF", tep: "TEP", auto: "Auto" };
  return (
    <div className="inline-flex items-center rounded-md border border-[var(--border)] bg-[var(--surface)] p-0.5" data-testid="format-toggle">
      {formats.map((f) => {
        const showResolved = f.id === "auto" && format === "auto" && resolvedFormat;
        const label = showResolved ? `Auto · ${SHORT[resolvedFormat] || resolvedFormat}` : f.label;
        const short = showResolved ? `A·${SHORT[resolvedFormat] || resolvedFormat}` : (SHORT[f.id] || f.label);
        return (
          <button
            key={f.id}
            onClick={() => setFormat(f.id)}
            title={showResolved ? `Auto — this league is valued as ${SHORT[resolvedFormat] || resolvedFormat}` : f.hint}
            className={`px-2 sm:px-3 h-8 rounded text-xs font-medium transition-colors ${
              format === f.id ? "bg-[var(--accent)] text-black" : "text-[var(--text-2)] hover:text-white"
            }`}
            data-testid={`format-${f.id}`}
          >
            <span className="sm:hidden">{short}</span>
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
